import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, Shield, Umbrella, Home as HomeIcon, PanelRight, Maximize2, Sun, Thermometer, Layers, Grid } from 'lucide-react';
export const Products = () => {
  const productCategories = [{
    id: 'verandas',
    title: "Veranda's",
    description: "Verander uw terras in een verlengstuk van uw woning met onze kwalitatief hoogwaardige veranda's.",
    products: [{
      name: 'Veranda polycarbonaat',
      description: 'Lichtgewicht, voordelig en UV-bestendig. Ideaal voor wie een praktische en betaalbare oplossing zoekt.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1kkTSutEG3n1jaMh5paBAH/487922126_17848235598441316_7489604228845729630_n.jpg',
      features: ['Lichtgewicht materiaal', 'UV-bestendig', 'Voordelige optie', 'Makkelijk te onderhouden']
    }, {
      name: 'Glazen veranda',
      description: 'Maximale lichtinval en een elegante uitstraling. Perfect voor wie een stijlvolle, transparante overkapping wenst.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6hFDuMkKtrrN66CxmjRtGR/488225866_17848235589441316_3303414385176099418_n.jpg',
      features: ['Optimale lichtinval', 'Luxe uitstraling', 'Duurzaam', 'Volledig transparant']
    }, {
      name: 'Lamellendak',
      description: 'Flexibele zonwering en ventilatie naar wens. Bepaal zelf hoeveel zonlicht en luchtcirculatie u wenst.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/31qoFLD89xVNfcg4Xki5Xk/491436229_17850212535441316_3063343797506131228_n.jpg',
      features: ['Verstelbare lamellen', 'Zonwering op maat', 'Optimale ventilatie', 'Waterdicht']
    }]
  }, {
    id: 'overkappingen',
    title: 'Overkappingen',
    description: 'Creëer een beschutte buitenruimte met onze op maat gemaakte overkappingen.',
    products: [{
      name: 'Vrijstaande overkapping',
      description: 'Creëer een extra buitenruimte op elke gewenste plek in uw tuin, onafhankelijk van uw woning.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bbqzAX3HGa1qV4DnaGXJAq/IMG-20250423-WA0011.jpg',
      features: ['Plaatsing overal mogelijk', 'Volledig op maat', 'Diverse dakopties', 'Robuuste constructie']
    }, {
      name: 'Carport',
      description: 'Bescherm uw auto tegen weersinvloeden met een stijlvolle en duurzame carport.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7nk9VQSmML7hwtXboprLaz/IMG-20250423-WA0012.jpg',
      features: ['Op maat gemaakt', 'Diverse dakbedekking', 'Duurzame materialen', 'Onderhoudsarm']
    }, {
      name: 'Rolling roof systems',
      description: 'Geniet van een flexibel daksysteem dat u kunt openen en sluiten wanneer u maar wilt.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c5PgifDabQSNHLLuTsSwGk/Afbeelding_van_WhatsApp_op_2025-05-13_om_12.42.34_8f7930e9.jpg',
      features: ['Openschuifbaar dak', 'Volledige controle', 'Waterdicht in gesloten positie', 'Moderne uitstraling']
    }]
  }, {
    id: 'wanden',
    title: 'Wanden & Deuren',
    description: 'Maak uw overkapping compleet met onze schuifwanden en deursystemen.',
    products: [{
      name: 'Glazen schuifwanden',
      description: 'Bescherm uw veranda tegen wind en regen zonder het uitzicht te belemmeren.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/31qoFLD89xVNfcg4Xki5Xk/491436229_17850212535441316_3063343797506131228_n.jpg',
      features: ['Volledig transparant', 'Eenvoudig te bedienen', 'Diverse openingsmogelijkheden', 'Windbestendig']
    }, {
      name: 'Schuifdeuren',
      description: 'Creëer een naadloze overgang tussen binnen en buiten met onze schuifdeursystemen.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6hFDuMkKtrrN66CxmjRtGR/488225866_17848235589441316_3303414385176099418_n.jpg',
      features: ['Ruimtebesparend', 'Soepele werking', 'Diverse formaten', 'Inbraakwerend']
    }, {
      name: 'Vouwwanden',
      description: 'Maximale opening en flexibiliteit met onze vouwwandsystemen.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1kkTSutEG3n1jaMh5paBAH/487922126_17848235598441316_7489604228845729630_n.jpg',
      features: ['Volledige opening mogelijk', 'Ruimtebesparend opgevouwen', 'Diverse configuraties', 'Hoogwaardige materialen']
    }]
  }, {
    id: 'overig',
    title: 'Overige diensten',
    description: "Veranova biedt meer dan alleen veranda's en overkappingen. Ontdek onze aanvullende diensten.",
    products: [{
      name: 'Tuin bestratingen',
      description: 'Complementeer uw veranda of overkapping met professionele bestrating voor een complete buitenruimte.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sQdRcEfDg3cmH2XT3UqKCc/Afbeelding_van_WhatsApp_op_2025-05-13_om_11.54.19_fa7eea2b.jpg',
      features: ['Diverse materialen', 'Professionele aanleg', 'Duurzame oplossingen', 'Perfecte aansluiting op uw veranda']
    }, {
      name: 'Hout/beton schuttingen',
      description: 'Creëer privacy en beschutting in uw tuin met onze schuttingen van hout of beton.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xxPuNDsXGaUcEKqqdjT9ZN/Afbeelding_van_WhatsApp_op_2025-05-13_om_11.54.17_d6a24884.jpg',
      features: ['Diverse uitvoeringen', 'Duurzame materialen', 'Professionele plaatsing', 'Onderhoudsarm']
    }, {
      name: 'Zandcement vloeren',
      description: 'Een solide basis voor uw veranda of overkapping met onze professioneel aangelegde zandcement vloeren.',
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6csxjgvfwC84VMs7DY8i12/IMG-20250423-WA0009.jpg',
      features: ['Vlakke afwerking', 'Duurzame ondergrond', 'Diverse afwerkingsmogelijkheden', 'Professionele aanleg']
    }]
  }];
  const additionalOptions = [{
    name: 'LED verlichting',
    description: 'Creëer sfeer en functionaliteit met geïntegreerde LED verlichting in uw veranda of overkapping.',
    icon: <Sun className="h-10 w-10" data-id="element-1370" />
  }, {
    name: 'Terrasverwarming',
    description: 'Verleng het seizoen en geniet ook in de koudere maanden van uw buitenruimte.',
    icon: <Thermometer className="h-10 w-10" data-id="element-1371" />
  }, {
    name: 'Screens & Zonwering',
    description: 'Bescherm uzelf tegen felle zon en creëer privacy met onze screens en zonwering op maat.',
    icon: <Shield className="h-10 w-10" data-id="element-1372" />
  }, {
    name: 'Domotica',
    description: 'Bedien uw veranda, zonwering en verlichting met één druk op de knop of via uw smartphone.',
    icon: <HomeIcon className="h-10 w-10" data-id="element-1373" />
  }];
  return <div className="min-h-screen bg-white w-full" data-id="element-1374">
      {/* Hero section */}
      <section className="relative -mt-[100px] pt-52 pb-32 bg-gray-900 overflow-hidden" data-id="element-1375">
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
        backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/6hFDuMkKtrrN66CxmjRtGR/488225866_17848235589441316_3303414385176099418_n.jpg')"
      }} data-id="element-1376"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/90 via-gray-900/70 to-gray-900/90" data-id="element-1377"></div>
        <div className="container mx-auto px-6 relative z-10" data-id="element-1378">
          <div className="max-w-3xl" data-id="element-1379">
            <div className="inline-flex items-center gap-3 mb-6" data-id="element-1380">
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-1381"></div>
              <span className="text-sm font-medium text-[#CDA735] uppercase tracking-wider" data-id="element-1382">
                Onze producten
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-1383">
              Ontdek ons <span className="text-[#CDA735]" data-id="element-1384">complete</span>{' '}
              assortiment
            </h1>
            <p className="text-xl text-white/80 mb-8 leading-relaxed" data-id="element-1385">
              Van veranda's en overkappingen tot schuifwanden en meer. Alles
              voor uw perfecte buitenruimte op één plek.
            </p>
          </div>
        </div>
      </section>
      {/* Product categories navigation */}
      <section className="py-8 bg-gray-50 border-b border-gray-200 sticky top-0 z-30" data-id="element-1386">
        <div className="container mx-auto px-6" data-id="element-1387">
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8" data-id="element-1388">
            {productCategories.map(category => <a key={category.id} href={`#${category.id}`} className="px-4 py-2 text-gray-700 hover:text-[#CDA735] font-medium transition-colors" data-id="element-1389">
                {category.title}
              </a>)}
            <a href="#extra-opties" className="px-4 py-2 text-gray-700 hover:text-[#CDA735] font-medium transition-colors" data-id="element-1390">
              Extra opties
            </a>
          </div>
        </div>
      </section>
      {/* Product categories */}
      {productCategories.map((category, categoryIndex) => <section key={category.id} id={category.id} className={`py-20 ${categoryIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`} data-id="element-1391">
          <div className="container mx-auto px-6" data-id="element-1392">
            <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1393">
              <div className="inline-flex items-center gap-3 mb-4 justify-center" data-id="element-1394">
                <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-1395"></div>
                <span className="text-sm font-medium text-[#B89429] uppercase tracking-wider" data-id="element-1396">
                  {category.title}
                </span>
                <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-1397"></div>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-1398">
                {category.title}
              </h2>
              <p className="text-lg text-gray-600" data-id="element-1399">{category.description}</p>
            </div>
            <div className="space-y-16" data-id="element-1400">
              {category.products.map((product, index) => <div key={product.name} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 !== 0 ? 'lg:flex-row-reverse' : ''}`} data-id="element-1401">
                  <div className={`order-2 ${index % 2 !== 0 ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-1402">
                    <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-1403">
                      <img src={product.image} alt={`${product.name} - ${product.description.substring(0, 50)}...`} className="w-full h-[400px] object-cover" data-id="element-1404" />
                    </div>
                  </div>
                  <div className={`order-1 ${index % 2 !== 0 ? 'lg:order-2' : 'lg:order-1'}`} data-id="element-1405">
                    <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1406">
                      {product.name}
                    </h3>
                    <p className="text-gray-600 text-lg mb-6" data-id="element-1407">
                      {product.description}
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6" data-id="element-1408">
                      {product.features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-1409">
                          <CheckCircle className="h-5 w-5 text-[#CDA735] mt-0.5 flex-shrink-0" data-id="element-1410" />
                          <span className="text-gray-700" data-id="element-1411">{feature}</span>
                        </div>)}
                    </div>
                    <div className="mt-8" data-id="element-1412">
                      <Link to="/offerte-aanvragen" className="inline-flex items-center bg-[#CDA735] hover:bg-[#B89429] text-white font-medium px-6 py-3 rounded-md shadow-md transition-all" data-id="element-1413">
                        <span data-id="element-1414">Vraag offerte aan</span>
                        <ArrowRight className="ml-2 h-5 w-5" data-id="element-1415" />
                      </Link>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>)}
      {/* Additional options */}
      <section id="extra-opties" className="py-20 bg-white" data-id="element-1416">
        <div className="container mx-auto px-6" data-id="element-1417">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1418">
            <div className="inline-flex items-center gap-3 mb-4 justify-center" data-id="element-1419">
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-1420"></div>
              <span className="text-sm font-medium text-[#B89429] uppercase tracking-wider" data-id="element-1421">
                Extra opties
              </span>
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-1422"></div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-1423">
              Maak uw project compleet
            </h2>
            <p className="text-lg text-gray-600" data-id="element-1424">
              Verhoog het comfort en functionaliteit van uw veranda of
              overkapping met deze aanvullende opties.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-1425">
            {additionalOptions.map((option, index) => <div key={index} className="bg-gray-50 p-8 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-1426">
                <div className="text-[#CDA735] mb-4" data-id="element-1427">{option.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-1428">
                  {option.name}
                </h3>
                <p className="text-gray-600 mb-6" data-id="element-1429">{option.description}</p>
                <a href="/offerte-aanvragen" className="inline-flex items-center text-[#CDA735] hover:text-[#B89429] font-medium" data-id="element-1430">
                  <span data-id="element-1431">Meer informatie</span>
                  <ArrowRight className="ml-2 h-4 w-4" data-id="element-1432" />
                </a>
              </div>)}
          </div>
        </div>
      </section>
      {/* CTA section */}
      <section className="py-16 bg-gray-900" data-id="element-1433">
        <div className="container mx-auto px-6" data-id="element-1434">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1435">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1436">
              Klaar om uw droomproject te realiseren?
            </h2>
            <p className="text-xl text-white/80 mb-8 max-w-2xl mx-auto" data-id="element-1437">
              Onze experts staan klaar om u te helpen bij het kiezen van de
              perfecte oplossing voor uw situatie.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1438">
              <a href="#contact" className="px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white rounded-md transition-colors flex items-center justify-center" data-id="element-1439">
                <span data-id="element-1440">Plan een adviesgesprek</span>
              </a>
              <Link to="/offerte-aanvragen" className="px-8 py-3.5 bg-[#CDA735] hover:bg-[#B89429] text-white rounded-md transition-colors flex items-center justify-center shadow-lg hover:shadow-[0_0_20px_rgba(205,167,53,0.3)]" data-id="element-1441">
                <span data-id="element-1442">Offerte aanvragen</span>
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-1443" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
};